import type { Mission } from '../missions.ts'

export const pbgc: Mission = {
  id: "pbgc",
  name: "Pension Benefit Guaranty Corporation",
  short: "PBGC",
  call: "Pensions",
  kind: "independent",
  url: "https://www.pbgc.gov/",
  established: 1974,
  palette: {
    primary: "#035087",
    secondary: "#112f4e",
    accent: "#ef3f43",
  },
  colorSource: {
    kind: "site",
    url: "https://www.pbgc.gov/",
  },
  motif: "shield",
  mission: {
    text: "PBGC’s mission is to enhance retirement security by preserving and encouraging the continuation of private pension plans and protecting the benefits of workers and retirees in traditional pension plans",
    url: "https://www.pbgc.gov/documents/fy-2026-2030-strategic-plan",
  },
  fact: {
    text: "PBGC was created by the Employee Retirement Income Security Act of 1974 and protects the retirement security of about 30 million American workers in private sector pension plans.",
    url: "https://www.pbgc.gov/about/who-we-are",
  },
  logo: {
    file: "public/logos/pbgc.svg",
    source: "https://commons.wikimedia.org/wiki/File:US-PensionBenefitGuarantyCorp-Logo.svg",
  },
  identifier: {
    about: "https://www.pbgc.gov/about",
    accessibility: "https://www.pbgc.gov/about/policies/website#accessibility",
    foia: "https://www.pbgc.gov/about/foia",
    noFear: "https://www.pbgc.gov/about/eeo",
    oig: "https://oig.pbgc.gov/",
    performance: "https://www.pbgc.gov/about/reports/budget-performance-planning",
    privacy: "https://www.pbgc.gov/about/privacy",
  },
  media: {
    photos: [
      {
        file: "/media/pbgc-erisa-signing.jpg",
        small: "/media/pbgc-erisa-signing-sm.jpg",
        alt: "President Gerald Ford at a lectern in the White House Rose Garden with members of Congress behind him for the ERISA signing",
        title: "President Gerald R. Ford and Members of Congress at the Signing Ceremony for the Employee Retirement Income Security Act of 1974 in the White House Rose Garden",
        creator: "White House Photographic Office, Gerald R. Ford Library",
        source: "https://catalog.archives.gov/id/12082613",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
